/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import 'whatwg-fetch'
import 'babel-polyfill'
import WebpackerReact from 'webpacker-react';

import 'initializers'
import KitIntegrator from 'views/Kits/integrators/KitIntegrator';
import DeleteKit from 'views/Kits/components/DeleteKit';
import Icon from 'views/Kits/components/Icon';
import SetsSearchIntegrator from 'views/Sets/integrators/SetsSearchIntegrator';
import SetsResultsIntegrator from 'views/Sets/integrators/SetsResultsIntegrator';
import ShareResourceIntegrator from 'views/ShareResource/integrators/ShareResourceIntegrator';

WebpackerReact.setup({
  KitIntegrator,
  DeleteKit,
  Icon,
  SetsSearchIntegrator,
  SetsResultsIntegrator,
  ShareResourceIntegrator,
});



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js